import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
  const [isHRServicesDropdownOpen, setIsHRServicesDropdownOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    const handleClickOutside = (event) => {
      if (isHRServicesDropdownOpen || isProductsDropdownOpen) {
        const dropdownElements = document.querySelectorAll('.nav-dropdown');
        let clickedOutside = true;
        
        dropdownElements.forEach(dropdown => {
          if (dropdown.contains(event.target)) {
            clickedOutside = false;
          }
        });
        
        if (clickedOutside) {
          setIsHRServicesDropdownOpen(false);
          setIsProductsDropdownOpen(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isHRServicesDropdownOpen, isProductsDropdownOpen]);

  const navItems = [
    { path: '/', label: 'Home' },
  ];

  const productsItems = [
    { 
      path: '/emploi-product', 
      label: 'Emploi',
      tagline: 'Redefining How Companies Find and Hire Talent'
    },
    { 
      path: '/payloi-product', 
      label: 'PeopleX HR',
      tagline: 'Payroll That Works as Hard as You Do'
    },
  ];

  const hrServicesItems = [
    { 
      id: 'general-staffing',
      path: '/general-staffing', 
      label: 'General Staffing and Recruitment'
    },
    { 
      id: 'it-staffing-recruitment',
      label: 'IT Staffing and Recruitment',
      subItems: [
        { path: '/krishpar-hiring', label: 'IT Hiring' },
        { path: '/it-staffing-contracts', label: 'IT Staffing' },
        { path: '/staff-augmentation', label: 'IT Staff Augmentation' }
      ]
    },
    { 
      id: 'workforce',
      path: '/workforce', 
      label: 'Workforce Solutions'
    },
    { 
      id: 'payroll-services',
      path: '/payroll-services', 
      label: 'Payroll Services'
    },
    { 
      id: 'hr-compliance-advisory',
      path: '/hr-compliance-advisory', 
      label: 'HR Compliance & Advisory'
    },
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link to="/" className="logo">
          <img src="/Logo.png" alt="Krishpar Technologies" className="logo-image" />
          {/* <span className="logo-text">Krishpar Technologies</span> */}
        </Link>

        <div className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          
          {/* HR Services Dropdown */}
          <div className="nav-dropdown">
            <button 
              className={`nav-link dropdown-toggle ${isHRServicesDropdownOpen ? 'open' : ''}`}
              onClick={() => {
                setIsHRServicesDropdownOpen(!isHRServicesDropdownOpen);
                setIsProductsDropdownOpen(false);
              }}
              onMouseEnter={() => !window.matchMedia("(max-width: 768px)").matches && setIsHRServicesDropdownOpen(true)}
              onMouseLeave={() => !window.matchMedia("(max-width: 768px)").matches && setIsHRServicesDropdownOpen(false)}
            >
              HR Services
              <svg className="dropdown-chevron" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div 
              className={`dropdown-menu ${isHRServicesDropdownOpen ? 'open' : ''}`}
              onMouseEnter={() => setIsHRServicesDropdownOpen(true)}
              onMouseLeave={() => setIsHRServicesDropdownOpen(false)}
            >
              {hrServicesItems.map((item) => (
                <div key={item.id} className={`dropdown-item-group ${item.subItems ? 'has-submenu' : ''}`}>
                  {item.path ? (
                    <Link
                      to={item.path}
                      className="dropdown-item"
                      onClick={() => {
                        setIsHRServicesDropdownOpen(false);
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      {item.label}
                      {item.subItems && (
                        <svg className="submenu-chevron" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </Link>
                  ) : (
                    <div 
                      className="dropdown-item has-submenu-trigger"
                      onClick={() => setActiveSubmenu(activeSubmenu === item.id ? null : item.id)}
                    >
                      {item.label}
                      {item.subItems && (
                        <svg className={`submenu-chevron ${activeSubmenu === item.id ? 'rotated' : ''}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </div>
                  )}

                  {item.subItems && (
                    <div className={`dropdown-submenu ${activeSubmenu === item.id ? 'open-mobile' : ''}`}>
                      {item.subItems.map((subItem) => (
                        <Link
                          key={subItem.path}
                          to={subItem.path}
                          className="dropdown-subitem"
                          onClick={() => {
                            setIsHRServicesDropdownOpen(false);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {subItem.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Products Dropdown */}
          <div className="nav-dropdown">
            <button 
              className={`nav-link dropdown-toggle ${isProductsDropdownOpen ? 'open' : ''}`}
              onClick={() => {
                setIsProductsDropdownOpen(!isProductsDropdownOpen);
                setIsHRServicesDropdownOpen(false);
              }}
              onMouseEnter={() => !window.matchMedia("(max-width: 768px)").matches && setIsProductsDropdownOpen(true)}
              onMouseLeave={() => !window.matchMedia("(max-width: 768px)").matches && setIsProductsDropdownOpen(false)}
            >
              Products
              <svg className="dropdown-chevron" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div 
              className={`dropdown-menu ${isProductsDropdownOpen ? 'open' : ''}`}
              onMouseEnter={() => setIsProductsDropdownOpen(true)}
              onMouseLeave={() => setIsProductsDropdownOpen(false)}
            >
              {productsItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="dropdown-item product-item"
                  onClick={() => {
                    setIsProductsDropdownOpen(false);
                    setIsMobileMenuOpen(false);
                  }}
                >
                  <div className="dropdown-item-heading">{item.label}</div>
                  <div className="dropdown-item-tagline">{item.tagline}</div>
                </Link>
              ))}
            </div>
          </div>

          {/* IT Services - Separate Main Tab */}
          <Link 
            to="/it-services" 
            className={`nav-link ${location.pathname === '/it-services' ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            IT Services
          </Link>

          <Link 
            to="/career" 
            className={`nav-link ${location.pathname === '/career' ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Careers
          </Link>

          <Link 
            to="/contact" 
            className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Contact Us
          </Link>
          
          {/* <Link 
            to="/contact" 
            className="nav-link nav-cta"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Get Started
          </Link> */}
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Header;
